import _ from "lodash";
import { apiServiceConstants, CONSTANTS } from "../../../../../constants";
import { apiService } from "../../../../../services/apiService";
import { utilService } from "../../../../../services/utilService";
import { doctorsListService } from "../../doctor-list-service";
import {
  doctorListResultInterface,
  RespDoctorListModel,
} from "../../doctor-list.model";
import { DoctorDataModel } from "./doctor-card.model";

const setInitialDoctorCardHeight = (doctorData: DoctorDataModel) => {
  const doctorCard = document.getElementById(`doctor-card-${doctorData.guid}`);
  if (
    doctorData.shiftTime?.length > 1 &&
    !_.isEmpty(doctorData.templateAvailability)
  ) {
    doctorCard?.style.setProperty("height", "120px");
  } else if (doctorData.shiftTime?.length > 1) {
    doctorCard?.style.setProperty("height", "110px");
  } else if (!_.isEmpty(doctorData.templateAvailability)) {
    doctorCard?.style.setProperty("height", "110px");
  } else {
    doctorCard?.style.setProperty("height", "95px");
  }

  const doctorCardNameDiv = document.getElementById(
    `doctor-details-div-${doctorData.guid}`
  );
  if (
    doctorData.shiftTime?.length === 0 &&
    _.isEmpty(doctorData.templateAvailability)
  ) {
    doctorCardNameDiv?.style.setProperty("margin-top", "2px");
  } else {
    doctorCardNameDiv?.style.setProperty("margin-top", "0px");
  }

  if (_.isEmpty(doctorData.shiftTime)) {
    const doctorDetails = document.getElementById(
      `doctor-card-${doctorData.guid}`
    );
  }
};

const removeCurrentCardItem = (doctorData: DoctorDataModel) => {
  const doctorCard = document.getElementById(`doctor-card-${doctorData.guid}`);
  // doctorCard?.style.setProperty("display", "none");
};

const alignMoreButton = (doctorData: DoctorDataModel) => {
  if (utilService.getScreenSize() === "large") {
    const moreButton = document.getElementById(
      `more-button-div-${doctorData.guid}`
    );
    moreButton?.style.setProperty("position", "absolute");
    moreButton?.style.setProperty("right", "115px");
    moreButton?.style.setProperty("top", "30px");
  }
};

const alignLessButton = (doctorData: DoctorDataModel) => {
  if (utilService.getScreenSize() === "large") {
    const lessButton = document.getElementById(
      `less-button-div-${doctorData.guid}`
    );
    lessButton?.style.setProperty("position", "absolute");
    lessButton?.style.setProperty("right", "115px");
    lessButton?.style.setProperty("top", "30px");
  }
};

const setDoctorBadgeColor = (doctorData: DoctorDataModel) => {
  const doctorColorBadge = document.getElementById(
    `doctor-color-badge-${doctorData.guid}`
  );
  if (doctorData.color) {
    const badgeColor = doctorData.color;
    doctorColorBadge?.style.setProperty("border-color", badgeColor);
  }
};
const increaseDoctorCardHeight = (doctorData: DoctorDataModel) => {
  const doctorCard = document.getElementById(`doctor-card-${doctorData.guid}`);
  let height = "";
  const heightIncreaseFactor = 100 + (doctorData.shiftTime?.length - 1) * 25;
  height = heightIncreaseFactor + "%";
  const styleString = "height:" + height;
  doctorCard?.setAttribute("style", styleString);
};

const decreaseDoctorCardHeight = (doctorData: DoctorDataModel) => {
  const doctorCard = document.getElementById(`doctor-card-${doctorData.guid}`);
  if (
    doctorData.shiftTime?.length > 1 &&
    !_.isEmpty(doctorData.templateAvailability)
  ) {
    doctorCard?.style.setProperty("height", "110px");
  } else if (doctorData.shiftTime?.length > 1) {
    doctorCard?.style.setProperty("height", "100px");
  } else {
    doctorCard?.style.setProperty("height", "90px");
  }
};

const showOnlineBadge = (
  doctorData: DoctorDataModel,
  componentName: string
) => {
  if (
    componentName === CONSTANTS.COMPONENTS.ONCALL_LOOK_UP ||
    componentName === CONSTANTS.COMPONENTS.FILE_SHARE
  ) {
    return true;
  } else {
    return false;
  }
};
const specialityTrim = (speciality: string) => {
  return speciality && speciality.split(/-(.+)/).length > 1
    ? speciality.split(/-(.+)/)[1]
    : speciality;
};

const availabilityTimeFormat = (time: string) => {
  if (time) {
    const [hours, minutes] = time.split(":");
    let hour = +hours;
    let ampm = hour < 12 ? " AM" : " PM";

    if (hour >= 12 && hour < 24) {
      ampm = " PM";
    } else if (hour === 0 || hour === 24) {
      hour = 12;
      ampm = " AM";
    }

    const finalHour = hour < 10 ? "0" + hour : hour;
    const formattedTime = `${finalHour}:${minutes}`;

    return formattedTime;
  }
};

const removeCardItemFromList = async (
  params: any
): Promise<doctorListResultInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/sboard-schedules/doctor-v2/?reg_code=` +
        utilService.getNetwork() +
        `&bedId=` +
        params.bedId +
        `&hour=` +
        params.hour +
        `&minute=` +
        params.minute +
        `&date=` +
        params.date,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const doctorListResp = res as RespDoctorListModel;
      const doctorListResponse = doctorsListService.setDoctorListModel(
        doctorListResp.result
      );
      const result: doctorListResultInterface = {
        isSuccess: true,
        doctorListResult: doctorListResponse,
        status: doctorListResp.status,
        message: doctorListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: doctorListResultInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

/**
 * unlink users from team
 */
const unlinkUserFromTeamList = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `team/unlink-teammate/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: true,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

/**
 * unlink provider from case details
 */
const unlinkProviderFromCase = async (params: any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `ems/remove-emergency-provider/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: true,
        status: response.status,
        message: response.message,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

/**
 * get selected user status
 */

const getUserStatusMessage = async (params: any,selectedNetwork?:any): Promise<any> => {
  const resApi = await apiService
    .apiCall(
      `user/profile-status-message/?reg_code=${utilService.getNetwork()}&n2n_network=${selectedNetwork}` +
        `&guid=` +
        params.guid,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as any;
      const result: any = {
        isSuccess: true,
        status: response.status,
        message: response.message,
        result: response.result,
      };
      return result;
    })
    .catch((error) => {
      const result: any = {
        isSuccess: false,
        message: error.message,
        status: error.status,
      };
      return result;
    });
  return resApi;
};

const handleErrorResponse = () => {};

export const doctorCardService = {
  setInitialDoctorCardHeight,
  increaseDoctorCardHeight,
  decreaseDoctorCardHeight,
  specialityTrim,
  setDoctorBadgeColor,
  availabilityTimeFormat,
  showOnlineBadge,
  handleErrorResponse,
  removeCurrentCardItem,
  removeCardItemFromList,
  alignMoreButton,
  alignLessButton,
  unlinkUserFromTeamList,
  unlinkProviderFromCase,
  getUserStatusMessage,
};
